export default "__VITE_ASSET__CuTf$nyk__"